export default {
    routerName: '广告管理',
    ad: {
        searchName: '検索条件',
        name: '广告名',
        spaceName: '广告位',
        sortOrder: '排序',
        hits: '浏览量',
        category: '类别',
        hot: '热门',
        recommend: '推荐',
        recommendTop: '推荐TOP',
        topic: '话题',
        type: '广告类型',
        typeImage: '图片',
        typeVideo: '正视频',
        typeRadio: '音频',
        pattern: '广告投放模式',
        startTime: '模式启用时间',
        endTime: '模式停用时间',
        patternHits: '模式浏览量',
        pDay: '按天起止',
        pHits: '按浏览量起止',
        createTime: '创建时间',
        status: '状态',
        open: '启用',
        close: '禁用',
    },
    table: {
        id: 'ID',
        name: '广告名',
        spaceName: '广告位',
        type: '广告类型',
        pattern: '广告投放模式',
        startTime: '模式启用时间',
        endTime: '模式停用时间',
        patternHits: '模式浏览量',
        sortOrder: '排序',
        hits: '浏览量',
        category: '类别',
        hot: '热',
        recommend: '荐',
        recommendTop: '荐T',
        topic: '话',
        createBy: '创建者',
        createTime: '创建时间',
        status: '状态',
        open: '启用',
        close: '禁用',
    },
};
